import React from "react";
import "../../assets/styles/reusableElements.scss";

type Props = {
  className?: string;
  children: string | string[];
  color?: string;
  style?: React.CSSProperties;
};

const Text = ({
  className,
  children,
  color,
  style,
}: // fontSize,
Props) => {
  let styleToInject;
  if (color) {
    styleToInject = { ...style, color };
  } else styleToInject = style;
  return (
    <p className={`${className} ${color}`} style={styleToInject}>
      {children}
    </p>
  );
};

export default Text;
